import React, { useEffect, useState } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import '../Pages/Css/Printing.css';
import axios from "axios";
import config from "../ip.json";
import Swal from "sweetalert2";
import Bill from "../Components/Bill"; // CSS 파일 임포트
import JSZip from 'jszip';
import {jsPDF} from "jspdf"; // JSZip 라이브러리 임포트

export const getList = async (companyName) => {
    const jwtToken = sessionStorage.getItem("Authorization");

    try {
        const response = await axios.get(config.url + "/v2/payment/company/not_paid", {
            params: {
                name: companyName,
            },
            headers: {
                Authorization: jwtToken,
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });

        // 데이터가 배열인지 확인
        if (Array.isArray(response.data)) {
            console.log("받은 데이터:", response.data);
            return response.data; // 데이터를 반환
        } else {
            console.warn("Response data is not an array, converting it.");
            return [];
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
            icon: "error",
            title: "데이터 요청 실패",
            text: "데이터를 가져오는 중 문제가 발생했습니다.",
        });
        return null; // 오류 발생 시 null 반환
    }
};

const Printing = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const { newArr, fileType ,bigoInfo } = location.state || {}; // state로 전달된 데이터 가져오기
    const [dataList, setDataList] = useState([]); // 상태로 관리
    const [renderedBills, setRenderedBills] = useState([]); // 렌더링된 고지서 목록
    const [imageArray, setImageArray] = useState([]); // 이미지를 저장할 배열

    console.log("전달받은 배열:", newArr);

    useEffect(() => {
        const fetchData = async () => {
            const tempDataList = []; // 임시 데이터 리스트
            for (let i = 0; i < newArr.length; i++) {
                console.log(`회사 데이터 요청: ${newArr[i].company}`);
                const data = await getList(newArr[i].company); // 비동기 데이터 가져오기
                if (data) tempDataList.push(data); // 데이터가 존재할 경우 추가
            }
            setDataList(tempDataList); // 최종적으로 상태 업데이트
        };

        if (newArr?.length) {
            fetchData();
        }
    }, [newArr]); // newArr 변경 시 실행

    useEffect(() => {
        if (dataList.length > 0) {
            const timeouts = dataList.map((_, index) => {
                return new Promise((resolve) => {
                    // setTimeout(() => {
                        setRenderedBills((prevBills) => [
                            ...prevBills,
                            <Bill
                                key={index}
                                companyName={newArr[index]?.company}
                                total_amount={newArr[index].total}
                                rooms={newArr[index].rooms || []}
                                deposit={newArr[index].deposit || "Unknown"}
                                dataList={dataList[index]} // 받은 데이터 리스트
                                bigoInfo={bigoInfo}
                                onSaveBillAsImage={handleSaveBillAsImage}
                            />
                        ]);
                        resolve();
                    // }); // 1초 간격
                });
            });

            // 모든 타임아웃이 완료되면 마지막으로 상태 업데이트
            Promise.all(timeouts).then(() => {
                console.log("모든 고지서가 렌더링되었습니다.");

            });
        }
    }, [dataList]); // dataList가 업데이트될 때마다 실행

    const handleSaveBillAsImage = (imageData, companyName) => {
        setImageArray((prevArray) => {
            const newArray = [...prevArray, { imageData, companyName }]; // 이미지와 회사명을 객체로 묶어서 배열에 추가
            // 배열의 길이가 newArr.length이면 ZIP으로 묶어 다운로드
            if (newArray.length === newArr.length) {
                if(fileType==="png"){
                    savePngAsZip(newArray); // 새로운 배열을 넘겨줌

                }else if(fileType==="pdf"){
                    savePdfAsZip(newArray);
                }
            }
            return newArray;
        });
    };

    const savePngAsZip = async (images) => {
        const zip = new JSZip(); // JSZip 인스턴스 생성

        // 이미지 URL을 순회하며 ZIP에 파일 추가
        const promises = images.map(async (item, index) => {
            const response = await fetch(item.imageData); // 이미지 데이터를 가져옴
            const blob = await response.blob(); // Blob 형태로 변환

            // Blob 데이터를 ZIP에 추가, 파일 이름에 회사명 사용
            zip.file(`${item.companyName}고지서.png`, blob);
        });

        // 모든 파일을 ZIP에 추가한 후 생성하고 다운로드
        Promise.all(promises)
            .then(() => {
                zip.generateAsync({ type: "blob" })
                    .then((content) => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(content);
                        link.download = "고지서(png).zip"; // ZIP 파일 이름 지정
                        link.click();
                                    navigate('/Print');

                    })
                    .catch((err) => {
                        console.error("ZIP 파일 생성 중 오류 발생:", err);
                    });
            })
            .catch((err) => {
                console.error("이미지 다운로드 중 오류 발생:", err);
            });
    };

    const savePdfAsZip = async (images) => {
        const zip = new JSZip(); // JSZip 인스턴스 생성

        // 이미지 URL을 순회하며 ZIP에 파일 추가
        const promises = images.map(async (item) => {
            const response = await fetch(item.imageData); // 이미지 데이터를 가져옴
            const blob = await response.blob(); // Blob 형태로 변환

            // jsPDF를 사용해 이미지를 PDF로 변환
            const pdf = new jsPDF();
            const img = new Image();
            img.src = URL.createObjectURL(blob);

            await new Promise((resolve) => {
                img.onload = () => {
                    const imgWidth = img.width;  // 이미지의 원본 가로 크기
                    const imgHeight = img.height; // 이미지의 원본 세로 크기

                    // PDF 페이지의 크기 (A4 크기 기준, mm 단위)
                    const pageWidth = pdf.internal.pageSize.getWidth(); // A4 페이지 가로 크기 (210mm)
                    const pageHeight = pdf.internal.pageSize.getHeight(); // A4 페이지 세로 크기 (297mm)

                    // 이미지의 비율을 계산
                    const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight); // 비율 고정 (가로와 세로 모두 페이지 크기 내로 맞추기)

                    const imgScaledWidth = imgWidth * ratio;  // 고정된 비율로 이미지 크기 계산
                    const imgScaledHeight = imgHeight * ratio;

                    // 이미지가 가로 중간에 배치되도록 좌측 여백 계산
                    const xPosition = (pageWidth - imgScaledWidth) / 2; // 가로 중간에 배치하기 위한 좌측 여백
                    const yPosition = 0; // 상단 여백 (필요시 수정 가능)

                    // 이미지가 PDF 페이지에 맞게 삽입
                    pdf.addImage(img, 'JPEG', xPosition, yPosition, imgScaledWidth, imgScaledHeight);

                    resolve();
                };
            });

            // PDF 파일을 ZIP에 추가, 파일 이름에 회사명 사용
            const pdfBlob = pdf.output('blob');
            zip.file(`${item.companyName}고지서.pdf`, pdfBlob);
        });

        // 모든 파일을 ZIP에 추가한 후 생성하고 다운로드
        await Promise.all(promises); // 모든 이미지 처리가 완료될 때까지 대기
        zip.generateAsync({ type: "blob" })
            .then((content) => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(content);
                link.download = "고지서(pdf).zip"; // ZIP 파일 이름 지정
                link.click();

                // ZIP 다운로드가 완료된 후 navigate 호출
                navigate('/Print');
            })
            .catch((err) => {
                console.error("ZIP 파일 생성 중 오류 발생:", err);
            });
    };
    useEffect(() => {
        window.scrollTo(0, document.body.scrollHeight);
    }, [handleSaveBillAsImage]);
    return (
        <div>
            <div className={'black-blur'}>
                <div className="loader">
                    <div className="intern">

                    </div>
                    <div className="external-shadow">
                        <div className="central">
                        </div>
                    </div>
                </div>
            </div>

            <div className={"payment-mainbox-right"}>
                {renderedBills}

            </div>
        </div>

    );
};

export default Printing;